import { ZfIcon, ZfStack, ZfTypography } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import type { ILiquidityCalculatorTableRow, LiquidityCalculatorSettingsSection } from '../../interfaces';

interface ILiquidityCalculatorAmountCellProps extends ICellRendererParams<ILiquidityCalculatorTableRow, number> {
    currency: string;
    onOpenSettingsDrawer: (section: LiquidityCalculatorSettingsSection) => void;
    onOpenNeedDetails: () => void;
}

export const LiquidityCalculatorAmountCell: FunctionComponent<ILiquidityCalculatorAmountCellProps> = ({
    api,
    data,
    node,
    value,
    valueFormatted,
    onOpenSettingsDrawer,
    onOpenNeedDetails,
}) => {
    const onEditClick = () => {
        if (!data?.showEdit && !data?.isAmountEditable) return;
        if (data?.isAmountEditable && node.rowIndex != null) {
            api.startEditingCell({ rowIndex: node.rowIndex, colKey: 'amount' });

            return;
        }

        if (data?.settingsSection) onOpenSettingsDrawer(data.settingsSection);
    };

    return (
        <ZfStack direction="row" spacing="medium" alignment="center" justify="flex-end" style={{ width: '100%' }}>
            {data?.showEdit || data?.isAmountEditable ? (
                <ZfIcon name="edit" size="medium" aria-hidden="true" onClick={onEditClick} style={{ cursor: 'pointer' }} />
            ) : null}
            {data?.showNeedDetails ? (
                <ZfIcon name="visibility" size="medium" aria-hidden="true" onClick={onOpenNeedDetails} style={{ cursor: 'pointer' }} />
            ) : null}
            <ZfTypography variant="body-small" color="normal" weight={data?.isTotal ? 'bold' : 'regular'} alignment="right" style={{ flex: 1 }}>
                {valueFormatted ?? value}
            </ZfTypography>
        </ZfStack>
    );
};
